/* tslint:disable */
import { enableProdMode, NgModuleRef } from '@angular/core';
import { disableDebugTools } from '@angular/platform-browser';
import { IEnvironment } from './iEnvironment';

enableProdMode();

// export const ENV_FIREBASE_CONFIG: any = FIREBASE_CONFIG;

export const environment: IEnvironment = {
  production: true,
  showDevModule: false,

  /** Angular debug tools in the dev console
   * https://github.com/angular/angular/blob/86405345b781a9dc2438c0fbe3e9409245647019/TOOLS_JS.md
   * @param modRef
   * @return {any}
   */
  decorateModuleRef(modRef: NgModuleRef<any>) {
    disableDebugTools();
    return modRef;
  },
  ENV_PROVIDERS: [

  ],
  //apiBaseUrl:"https://stable.fintfm.ru/api/v1/",
  //fintFMUrl: "https://stable.fintfm.ru/",
  //fintFM2Url: "https://stable.fintfm.ru/web",
  apiBaseUrl:"https://fintfm.ru/api/v1/",
  fintFMUrl: "https://fintfm.ru/",
  fintFM2Url: "https://fintfm.ru/web",
};
